import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css'; // ← これを追加
import "./styles/bbs.css"; // 共通CSSもここで読み込んでOK

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
